import React, { ReactNode } from 'react';
import { Box, Stack } from '@mui/material';
import Navbar from './Navbar';
import Footer from './Footer';

interface Props {
  children: ReactNode;
}

const NAVBAR_HEIGHT = 64;
const FOOTER_HEIGHT = 48;

const StandardView = ({ children }: Props) => {
  return (
    <Box height="100vh" display="flex" flexDirection="column">
      <Box sx={{ position: 'fixed', top: 0, width: '100%', zIndex: 1100 }}>
        <Navbar />
      </Box>

      <Box
        sx={{
          marginTop: `${NAVBAR_HEIGHT}px`,
          marginBottom: `${FOOTER_HEIGHT}px`,
          paddingBottom: '24px',
          flex: 1,
          overflow: 'auto',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {children}
      </Box>

      <Box sx={{ position: 'fixed', bottom: 0, width: '100%', zIndex: 1100 }}>
        <Footer />
      </Box>
    </Box>
  );
};

export default StandardView;
